module.exports = __webpack_public_path__ + "static/media/divided-we-fail.9e9bbf98.jpg";